import React, { useEffect, useState } from 'react';
import Header from 'components/Header/Header';
import * as Constants from 'constants/Constants';
import { connect } from 'react-redux';
import { getAccount, getAccounts, toggleAccountMapping } from 'store/actions/accountActions';
import { setDashboardUrl, updateAccountId, updatePageName, updateSession } from '../store/actions';
import Spinner from 'components/UI/Spinner/Spinner';
import UnAuthorizedUser from 'components/signin/UnAuthorizedUser/UnAuthorizedUser';
import TrustCenter from 'components/TrustCenter/TrustCenter';
import { setLoggedInUser } from 'store/actions/termsAndConditionsActions';
import AgreementTermsMapping from 'components/TermsConditions/AgreementTermsMapping';

import { isBlank, isNotBlank } from 'components/Common/Utils/StringUtils';
import authenticationManager from './AuthenticationManager';
import { fetchAccessToken, getUserInfo } from '@ttc/authenticator/lib/Authenticator';
import { setUserSession, updateUserActivity } from '../components/Common/Utils/ResourceUtils';
import { event } from 'components/Common/Utils/ReactGa4Utils';
import { ROUTES } from 'constants/Constants';
const Dashboard = (props) => {
    const { loggedInUserTerms, session, updateSession, firstTimeUserLogin } = props;

    const [dashboard, setDashboard] = useState({
        userName: '',
        userId: '',
        userRole: '',
        accountId: '',
        accountType: [],
        isCarrier: null,
        isTenantIdMapped: null,
        isCompanyIdMapped: null
    });

    useEffect(() => {
        const {
            userName,
            userId,
            userRole,
            accountId,
            accountType,
            isCarrier,
            isTenantIdMapped,
            isCompanyIdMapped
        } = session;
        setDashboard({
            userName,
            userId,
            userRole,
            accountId,
            accountType,
            isCarrier,
            isTenantIdMapped,
            isCompanyIdMapped,
            isVisibilityProvider:
                session?.accountType?.includes(Constants.VISIBILITY_PROVIDER) ||
                userRole === Constants.VISIBILITY_PROVIDER
        });
    }, [session]);

    const access_token = sessionStorage.getItem('access_token');
    const urlAccountId = sessionStorage.getItem('urlAccountId');
    const [userInfo, setUserInfo] = useState({});

    const handleError = (error, source) => {
        const errorCode = error?.response?.status;
        console.warn('[Dashboard access] API error redirect', {
            source,
            status: errorCode,
            url: error?.config?.url,
            message: error?.message,
            redirectTo: errorCode === 403 ? '/restricted-access' : ROUTES.UNAUTHORIZED_ACCESS
        });
        if (errorCode === 403) {
            props.history.push('/restricted-access');
        } else {
            props.history.push(ROUTES.UNAUTHORIZED_ACCESS);
        }
    };

    useEffect(() => {
        if (isBlank(access_token)) {
            console.info('[Dashboard access] No access_token in sessionStorage; fetching token');
            fetchAccessToken(props, authenticationManager, Constants.DASHBOARD_ROUTE);
        } else {
            updateUserActivity(Constants.USER_LOGIN)
                .then(() => {
                    getUserInfo(authenticationManager)
                        .then((res) => {
                            event('LOG IN', 'User Logged In', `${res.account_name}`);
                            return setUserInfo(res);
                        })
                        .catch((error) => handleError(error, 'getUserInfo'));
                })
                .catch((error) => handleError(error, 'updateUserActivity'));
        }
        if (dashboard.isTenantIdMapped && dashboard.userRole !== 'USER' && dashboard.isCarrier) {
            const isTenantIdMapped = sessionStorage.getItem('isTenantIdMapped');
            setDashboard({ ...dashboard, isTenantIdMapped: isTenantIdMapped });
        }
    }, []);

    useEffect(() => {}, [props.loggedInUserTerms, props.loggedInUserTCPermission]);

    useEffect(() => {
        userInfo && setUserSession(userInfo, false);
    }, [userInfo]);

    let dashBoardContent = <Spinner />;
    let dashBoardName = '';

    if (dashboard.userRole === 'SYSTEM_ADMIN' && isNotBlank(urlAccountId)) {
        dashBoardContent = <TrustCenter accountId={dashboard.accountId} />;
        dashBoardName = Constants.DASHBOARD_TRUST_CENTER;
        props.updatePageName(Constants.DASHBOARD_TRUST_CENTER);
        props.history.push(ROUTES.CONNECTIONS);
    } else if (dashboard.userRole === 'SYSTEM_ADMIN') {
        dashBoardContent = <UnAuthorizedUser />;
        props.history.push(ROUTES.UNAUTHORIZED_ACCESS);
    } else if (dashboard.isCarrier === false && dashboard.isVisibilityProvider === true) {
        dashBoardContent = null;
        dashBoardName = 'Sharing Agreements';
        props.updatePageName('Sharing Agreements');
        props.history.push(ROUTES.SHARING_AGREEMENTS);
    } else if (dashboard.isCarrier === false) {
        dashBoardContent = <UnAuthorizedUser />;
        props.history.push(ROUTES.UNAUTHORIZED_ACCESS);
    }

    if (
        Object.entries(loggedInUserTerms).length > 0 &&
        loggedInUserTerms !== undefined &&
        props.loggedInUserTCPermission !== undefined
    ) {
        if (!props.loggedInUserTerms.is_agreed && props.loggedInUserTCPermission) {
            dashBoardContent = <AgreementTermsMapping />;
            dashBoardName = Constants.DASHBOARD_AGREEMENT_TERMS;
            props.updatePageName(Constants.DASHBOARD_AGREEMENT_TERMS);
            props.history.push('/agreement-terms');
        } else if (
            dashboard.isCarrier &&
            !dashboard.isTenantIdMapped &&
            dashboard.userRole === 'ACCOUNT_ADMIN' &&
            firstTimeUserLogin
        ) {
            dashBoardContent = <TrustCenter accountId={dashboard.accountId} />;
            dashBoardName = Constants.DASHBOARD_TRUST_CENTER;
            props.updatePageName(Constants.DASHBOARD_TRUST_CENTER);
            updateSession({ selected_accountId: session.accountId });
            props.history.push(ROUTES.CONNECTIONS);
        } else if (
            (dashboard.isCarrier && dashboard.isTenantIdMapped) ||
            dashboard.isCompanyIdMapped ||
            !firstTimeUserLogin
        ) {
            dashBoardContent = <TrustCenter accountId={dashboard.accountId} />;
            dashBoardName = Constants.DASHBOARD_TRUST_CENTER;
            props.updatePageName(Constants.DASHBOARD_TRUST_CENTER);
            updateSession({ selected_accountId: session.accountId });
            const path = sessionStorage.getItem('pathname');
            [
                ROUTES.ROOT,
                ROUTES.UNAUTHORIZED_ACCESS,
                ROUTES.IDENTITY_PROVIDER_QUERY_PARAM
            ].includes(path)
                ? props.history.push(ROUTES.CONNECTIONS)
                : props.history.push(path);
        } else if (dashboard.userRole === 'USER') {
            dashBoardContent = <UnAuthorizedUser />;
            props.history.push(ROUTES.UNAUTHORIZED_ACCESS);
        } else if (dashboard.isCarrier === false) {
            dashBoardContent = <UnAuthorizedUser />;
            props.history.push(ROUTES.UNAUTHORIZED_ACCESS);
        }
    }

    return dashBoardName !== '' ? (
        <Spinner />
    ) : (
        <div>
            <Header />
            <div className="card-body dash-card">{dashBoardContent}</div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    accounts: state.accounts.accounts,
    account: state.accounts.account,
    showDetail: state.accounts.showDetail,
    showModal: state.accounts.showModal,
    accountAdmin: state.accounts.accountAdmin,
    accountUser: state.accounts.accountUser,
    loggedInUserTerms: state.termsAndConditions.loggedInUserTerms,
    session: state.session.sessionValue,
    loggedInUserTCPermission: state.termsAndConditions.loggedInUserTCPermission,
    firstTimeUserLogin: state.termsAndConditions.firstTimeUserLogin
});

export default connect(mapStateToProps, {
    setDashboardUrl,
    getAccounts,
    getAccount,
    toggleAccountMapping,
    updatePageName,
    updateAccountId,
    setLoggedInUser,
    updateSession
})(Dashboard);
